/* =========================================
 * GUAM ROUTE — Product Page Enhancements
 * 1. Shipping Timeline (horizontal)
 * 2. Sticky Add to Cart (mobile)
 * INP optimized: deferred click, passive events
 * ========================================= */
(function() {

  /* --- 1. SHIPPING TIMELINE --- */
  var buyButtons = document.querySelector('.buy-buttons-block, [class*="buy-buttons"], form[action*="/cart/add"]');

  if (buyButtons) {
    var el = document.createElement('div');
    el.id = 'gr-shipping-timeline';
    el.innerHTML = '<p style="font-size:.65rem;font-weight:700;color:#191970;letter-spacing:.08em;text-transform:uppercase;margin:0 0 8px;text-align:center">\ud83d\udce6 ESTIMATED DELIVERY</p>'
      + '<div id="gr-ship-row">'
        + step('\ud83d\uded2', 'Today',    'Order Placed')
        + line()
        + step('\ud83d\udce6', '1\u20132 Days', 'Processing')
        + line()
        + step('\ud83d\ude9a', '3\u20135 Days', 'Shipped')
        + line()
        + step('\ud83c\udfe0', '5\u201310 Days', 'Delivered')
      + '</div>';
    buyButtons.insertAdjacentElement('afterend', el);
  }

  function step(icon, date, desc) {
    return '<div class="gr-ship-step">'
      + '<div class="gr-ship-icon">' + icon + '</div>'
      + '<span class="gr-ship-date">' + date + '</span>'
      + '<span class="gr-ship-desc">' + desc + '</span>'
      + '</div>';
  }

  function line() {
    return '<div class="gr-ship-line"></div>';
  }

  /* --- 2. STICKY ADD TO CART (mobile only) --- */
  if (window.innerWidth > 749) return;

  var atcForm = document.querySelector('form[action*="/cart/add"]');
  if (!atcForm) return;

  var title  = document.querySelector('.product__title, .product-information h1, h1.title');
  var price  = document.querySelector('.price-item--regular, .price-item--sale, .price__regular .price-item');
  var addBtn = atcForm.querySelector('[type="submit"]');
  if (!addBtn) return;

  var bar = document.createElement('div');
  bar.className = 'product-sticky-atc';
  bar.innerHTML =
    '<p class="product-sticky-atc__title">' + (title ? title.textContent.trim() : 'Add to Cart') + '</p>' +
    '<span class="product-sticky-atc__price">' + (price ? price.textContent.trim() : '') + '</span>' +
    '<button class="product-sticky-atc__btn" type="button">ADD TO CART</button>';
  document.body.appendChild(bar);

  /* INP fix: yield main thread before cart submit so browser can paint first */
  bar.querySelector('.product-sticky-atc__btn').addEventListener('click', function() {
    setTimeout(function() { addBtn.click(); }, 0);
  }, { passive: true });

  var visObserver = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      bar.classList.toggle('is-visible', !entry.isIntersecting);
    });
  }, { threshold: 0.1 });
  visObserver.observe(atcForm);

})();
